import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LifePlan, LifePlanProjection } from '@core/models/life-plan.model';
import { environment } from '@environment';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { ClientData } from '@core/models/client-data.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LifePlanService {
  constructor(private http: HttpClient, private store: Store<AppState>) {}

  createAgentLifePlan(lifePlan: LifePlan) {
    return this.http.post<LifePlan>(
      `${environment.financialPlanner.url}/life-plans`,
      lifePlan
    );
  }

  getAgentLifePlansProjections(
    clientId: string,
    orderBy: string,
    order: 'asc' | 'desc' = 'desc',
    limit?: number,
    lastEvaluatedKey?: string
  ) {
    let params = new HttpParams().appendAll({
      clientId,
      orderBy,
      order,
    });
    if (limit) {
      params = params.set('limit', String(limit));
    }
    if (lastEvaluatedKey) {
      params = params.set('lastEvaluatedKey', lastEvaluatedKey);
    }
    return this.http.get<{
      lifePlans: LifePlanProjection[];
      lastEvaluatedKey?: string;
    }>(`${environment.financialPlanner.url}/life-plans`, {
      params,
    });
  }

  getLifePlan(lifePlanId: string, clientId: string) {
    return this.http.get<LifePlan>(
      `${environment.financialPlanner.url}/life-plans/${lifePlanId}`
    );
  }

  updateLifePlan(lifePlan: LifePlan) {
    return this.http.put<LifePlan>(
      `${environment.financialPlanner.url}/life-plans/${lifePlan.id}`,
      lifePlan
    );
  }

  deleteAgentLifePlan(lifePlanId: string, clientId: string) {
    const params = new HttpParams().append('clientId', clientId);
    return this.http.delete<LifePlan>(
      `${environment.financialPlanner.url}/life-plans/${lifePlanId}`,
      { params }
    );
  }

  importAgentLifePlan(lifePlanId: string, newLifePlanTitle: string) {
    return this.http.post(
      `${environment.financialPlanner.url}/life-plans/${lifePlanId}/import`,
      {
        title: newLifePlanTitle,
      }
    );
  }

  getClientData(clientId: string): Observable<ClientData> {
    const params = new HttpParams().append('clientId', clientId);

    return this.http.get<ClientData>(
      `${environment.financialPlanner.url}/client-data`,
      {
        params,
      }
    );
  }
}
